export default __webpack_public_path__ + "static/media/madame_detail2.f0f097c5.jpg";